var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"pt-1 pl-0 pb-1 pr-0",attrs:{"cols":"auto"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }